module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/6-d5885a7179579525b0c81752aa4daafb.png";